/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Column_EmptyInputs */

const en_column_empty = /** @type {(inputs: Column_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No items`)
};

const de_column_empty = /** @type {(inputs: Column_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keine Vorgänge`)
};

/**
* | output |
* | --- |
* | "No items" |
*
* @param {Column_EmptyInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const column_empty = /** @type {((inputs?: Column_EmptyInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Column_EmptyInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_column_empty(inputs)
	return en_column_empty(inputs)
});